import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGbEng = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 15", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 25, height: 15, fill: "#FFF" }), /* @__PURE__ */ React.createElement("g", { fill: "#CE1124" }, /* @__PURE__ */ React.createElement("rect", { width: 3, height: 15, x: 11 }), /* @__PURE__ */ React.createElement("rect", { width: 25, height: 3, y: 6 })));
const ForwardRef = forwardRef(SvgGbEng);
const Memo = memo(ForwardRef);
export default Memo;
